<template>
    <div id="wholesaleFooter">
        <div id="addressDiv">
            <div id="addressOnlineDiv" class="locationData">
                online.cars 
            </div>

            <div class="appDetailsDivider">
                &#8226;
            </div>
            
            <div id="physicalAddressDiv" class="locationData">
                <span> 
                    179 Commerce Drive&nbsp;
                </span>
                <span>
                    Loveland, OH 45140
                </span>
            </div>

            <div class="appDetailsDivider">
                &#8226;
            </div>

            <div id="appPhoneDiv" class="locationData">
                888-890-1116
            </div>
        </div>
    </div>
</template>

<script>
</script>

<style>
    #wholesaleFooter {
        background-color: #2B2A2B;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: calc(10 * var(--vw));
        bottom: 0;
        height: calc(3 * var(--vh));
        width: calc(90 * var(--vw));
    }

    .inmobile #wholesaleFooter {
        width: calc(100 * var(--vw));
        height: calc(5 * var(--vh));
        position: fixed;
        left: 0;
        bottom: 0;
    }

    #addressDiv {
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: calc(.85 * var(--vw));
        font-weight: lighter;
    }

    .inmobile #addressDiv {
        font-size: calc(1.6 * var(--vh));
        align-items: flex-start;
    }

    .locationData {
        margin: calc(.25 * var(--vh)) calc(1 * var(--vw));
    }

    .inmobile .locationData {
        margin: calc(.5 * var(--vw)) calc(2 * var(--vw));
    }

    #addressOnlineDiv {
        white-space: nowrap;
    }

    #physicalAddressDiv {
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: fit-content
    }

    .inmobile #physicalAddressDiv {
        flex-wrap: wrap;
    }

    #physicalAddressDiv {
        white-space: nowrap;
    }

    #appPhoneDiv {
        white-space: nowrap;
    }
</style>